import React from 'react'
import styled from 'styled-components'
import Container from 'components/elements/container'
import ReactMarkdown from 'react-markdown'
import { fontWeight } from 'themes/font'
import breakPoints from 'themes/breakPoints'
import { Icon } from '@blueprintjs/core'

const Section = styled.section`
  padding: 64px 0;
`

const Heading = styled.h1`
  display: inline-block;
  background: url('/img/investor/presentation-heading-bg.png');
  background-size: cover;
  color: #fff;
  font-size: 2rem;
  font-weight: ${fontWeight.bold};
  padding: 32px 64px;
  border-radius: 8px;
  margin-top: 0;
  margin-bottom: 32px;
  @media (max-width: ${breakPoints.md.max}px) {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 32px;
    padding: 24px;
    font-size: 1.5rem;
  }
`

const Content = styled.div`
  h2 {
    font-size: 1.5rem;
    margin-top: 0;
    margin-bottom: 16px;
    font-weight: ${fontWeight.medium};
  }
  p {
    font-size: 1rem;
    margin-bottom: 16px;
  }
  @media (max-width: ${breakPoints.md.max}px) {
    h2 {
      font-size: 1.25rem;
      margin-bottom: 16px;
    }
    p {
      font-size: 1rem;
      margin-bottom: 16px;
    }
  }
`

const SeeMore = styled.a`
  padding: 8px 32px;
  border: 2px solid #0984e3;
  color: #0984e3;
  font-size: 1rem;
  height: 50px;
  border-radius: 25px;
  display: inline-flex;
  align-items: center;
  .bp3-icon {
    margin-left: 8px;
  }
  @media (max-width: ${breakPoints.md.max}px) {
    font-size: 1rem;
    display: flex;
    justify-content: center;
  }
`

const Presentation = ({ data: { heading, content, seeMore } }) => {
  return (
    <Section className='wow fadeIn'>
      <Container>
        <Heading>{heading}</Heading>
        <Content>
          <ReactMarkdown source={content} />
          <SeeMore href={seeMore.link}>
            {seeMore.text}
            <Icon icon='arrow-right' iconSize={24} />
          </SeeMore>
        </Content>
      </Container>
    </Section>
  )
}

export default Presentation
